import styled, { css } from 'styled-components';
import React from 'react';

import {
  FaInfoCircle,
  FaExclamationTriangle,
  FaCheckCircle,
  FaReceipt
} from 'react-icons/fa';
import { TbMessageCog } from 'react-icons/tb';

/**
 * Componente estilizado para um contêiner de chip com diferentes estilos visuais baseados no tipo.
 * @component ChipContainer
 *
 * @param {Object} props - Propriedades do componente
 * @param {string} [props.type] - Determina o estilo visual do chip
 *   - 'info': Tema azul com texto verde-água
 *   - 'warn': Tema laranja com texto âmbar
 *   - 'success': Tema verde com texto verde escuro
 *   - 'danger': Tema vermelho com texto vermelho escuro
 */
/**
 * Estilos do componente FlexChip.
 *
 * @module FlexChip/styles
 * @exports ChipContainer - Componente estilizado que representa o contêiner principal do chip
 *
 * O componente aceita as seguintes propriedades:
 * @prop {string} type - Define o tipo/estilo visual do chip:
 *   - 'info': Azul claro com texto verde escuro
 *   - 'warn': Laranja claro com texto amarelo escuro
 *   - 'success': Verde claro com texto verde escuro
 *   - 'danger': Vermelho claro com texto vermelho escuro
 */

export const ChipContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 14px;

  ${(props) =>
    props.type === 'info' &&
    css`
      background-color: #e0f7fa;
      color: #00796b;
    `}

  ${(props) =>
    props.type === 'protocol' &&
    css`
      background-color: #e0f7fa;
      color: #00796b;
    `}

      ${(props) =>
    props.type === 'template' &&
    css`
      background-color: #e0f7fa;
      color: #00796b;
    `}

  ${(props) =>
    props.type === 'warn' &&
    css`
      background-color: #fff3e0;
      color: #e3a723;
    `}

  ${(props) =>
    props.type === 'success' &&
    css`
      background-color: #e8f5e9;
      color: #388e3c;
    `}

  ${(props) =>
    props.type === 'danger' &&
    css`
      background-color: #ffebee;
      color: #d32f2f;
    `}
`;

export const Icon = styled.div`
  margin-right: 8px;

  ${(props) =>
    props.type === 'info' &&
    css`
      color: #00796b;
    `}

  ${(props) =>
    props.type === 'protocol' &&
    css`
      color: #00796b;
    `}

    ${(props) =>
    props.type === 'template' &&
    css`
      color: #00796b;
    `}

  ${(props) =>
    props.type === 'warn' &&
    css`
      color: #e3a723;
    `}

  ${(props) =>
    props.type === 'success' &&
    css`
      color: #388e3c;
    `}
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
`;

export const getIcon = (type) => {
  switch (type) {
    case 'danger':
      return <FaExclamationTriangle />;
    case 'warn':
      return <FaExclamationTriangle />;
    case 'success':
      return <FaCheckCircle />;
    case 'template':
      return <TbMessageCog />;
    case 'protocol':
      return <FaReceipt />;
    case 'info':
    default:
      return <FaInfoCircle />;
  }
};
